export default __webpack_public_path__ + "028e4dea1ea44aa41e1cc9beb13890f4.svg";